import {Injectable} from '@angular/core';
import {SurveyResearchHeaderModel} from '../views/models/survey-research-header.model';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject} from 'rxjs';
import {AWSS3Image} from '../views/models/AWSS3Image.model';
import {SurveyResearchModel} from '../views/models/survey-research.model';
import {environment} from '../../environments/environment';

export class ChartModel {
  arg: any;
  val: number;
}

@Injectable({
  providedIn: 'root'
})
export class SurveyHeaderService {

  survey_header_change$ = new BehaviorSubject<SurveyResearchHeaderModel[]>([]);
  survey_result_change$ = new BehaviorSubject<SurveyResearchModel[]>([]);
  filtered_result_change$ = new BehaviorSubject<SurveyResearchModel[]>([]);
  notificationResultData_change$ = new BehaviorSubject<SurveyResearchHeaderModel>(new SurveyResearchHeaderModel());
  weekly_chart_result_change$ = new BehaviorSubject<ChartModel[]>([]);
  weekly_participant$ = new BehaviorSubject<number>(0);
  weekly_avg = new BehaviorSubject<number>(0);
  monthly_chart_result_change$ = new BehaviorSubject<ChartModel[]>([]);
  month_participant$ = new BehaviorSubject<number>(0);
  month_avg = new BehaviorSubject<number>(0);
  total_chart_result_change$ = new BehaviorSubject<ChartModel[]>([]);
  total_participant$ = new BehaviorSubject<number>(0);
  total_avg = new BehaviorSubject<number>(0);
  logoImage_change$ = new BehaviorSubject<AWSS3Image>(new AWSS3Image());

  all_survey_date_avg$ = new BehaviorSubject<ChartModel[]>([]);
  week_survey_date_avg$ = new BehaviorSubject<ChartModel[]>([]);
  month_survey_date_avg$ = new BehaviorSubject<ChartModel[]>([]);

  constructor(private httpClient: HttpClient) {
  }

  getSurveyImage(id: number, directory: string) {
    this.httpClient.get(environment.baseURL + '/v2/api' + '/listbucketitems?bucketname=b1development&directory=icibotV2/' + id + '/' + directory).subscribe(
      (datas: AWSS3Image[]) => {
        if (datas) {
          datas.forEach(x => x.url = x.url + '?' + (new Date()).getTime());
          // @ts-ignore
          datas.sort((a, b) => new Date(a.last_modified) - new Date(b.last_modified));
          if (directory == 'SurveyImage') {
            this.logoImage_change$.next(datas[0]);
          }
        }
      },
      error => {
        console.log(error);
      },
    );
  }

  getSurveyHeader(hotelId) {
    this.httpClient.get(environment.baseURL + '/v2/api' + '/survey_headers/' + hotelId).subscribe(
      (surveyHeader: SurveyResearchHeaderModel[]) => {
        surveyHeader = surveyHeader.sort((a, b) => b.id - a.id);
        this.survey_header_change$.next(surveyHeader);
      }
    );
  }

  GETResultResearchWithProfiles(type, id) {
    this.httpClient.get(environment.baseURL + '/v2/api' + '/result_research_with_profiles?' + type + '=' + id).subscribe(
      (resp: SurveyResearchModel[]) => {
        resp = resp.sort((a, b) => new Date(b.rate_date).getTime() - new Date(a.rate_date).getTime());
        this.survey_result_change$.next(resp);
        this.filtered_result_change$.next(resp);
      }
    );
  }

  filterData(internal: string, rate?: number) {
    let date: Date = new Date();
    if (internal == 'week') {
      date = new Date(date.setDate(date.getDate() - 7));
    } else if (internal == 'month') {
      date = new Date(date.setDate(date.getDate() - 30));
    } else if (internal == 'total') {
      date = new Date(2020, 1, 1, 1, 1, 1, 1);
    } else {
      this.filtered_result_change$.next(this.survey_result_change$.getValue());
      return;
    }
    const filteredData = this.survey_result_change$.getValue().filter(x => x.rate == rate && new Date(x.rate_date) >= date);
    this.filtered_result_change$.next(filteredData);
  }

  GETChartResult(type, id) {
    this.httpClient.get(environment.baseURL + '/v2/api' + '/chart_survey/week?' + type + '=' + id).subscribe(
      (resp: ChartModel[]) => {
        this.weekly_chart_result_change$.next(resp);
        let participant = 0;
        let rate = 0;
        if (resp) {
          resp.forEach(x => {
            participant += x.val;
            rate += x.arg * x.val;
          });
        }
        this.weekly_participant$.next(participant);
        this.weekly_avg.next(Number((rate / participant).toFixed(3)));
      }
    );
    this.httpClient.get(environment.baseURL + '/v2/api' + '/chart_survey/month?' + type + '=' + id).subscribe(
      (resp: ChartModel[]) => {
        this.monthly_chart_result_change$.next(resp);
        let participant = 0;
        let rate = 0;
        if (resp) {
          resp.forEach(x => {
            participant += x.val;
            rate += x.arg * x.val;
          });
        }
        this.month_participant$.next(participant);
        this.month_avg.next(Number((rate / participant).toFixed(3)));
      }
    );
    this.httpClient.get(environment.baseURL + '/v2/api' + '/chart_survey/all?' + type + '=' + id).subscribe(
      (resp: ChartModel[]) => {
        this.total_chart_result_change$.next(resp);
        let participant = 0;
        let rate = 0;
        if (resp) {
          resp.forEach(x => {
            participant += x.val;
            rate += x.arg * x.val;
          });
        }
        this.total_participant$.next(participant);
        this.total_avg.next(Number((rate / participant).toFixed(3)));
      }
    );
  }

  GETChartDateAvg(type, id) {
    this.httpClient.get(environment.baseURL + '/v2/api' + '/chart_date_avg/all?' + type + '=' + id).subscribe(
      (resp: ChartModel[]) => {
        if (resp) {
          resp.forEach(x => {
            x.arg = new Date(x.arg);
          });
        }
        this.all_survey_date_avg$.next(resp);
      }
    );
    this.httpClient.get(environment.baseURL + '/v2/api' + '/chart_date_avg/week?' + type + '=' + id).subscribe(
      (resp: ChartModel[]) => {
        if (resp) {
          resp.forEach(x => {
            x.arg = new Date(x.arg);
          });
        }
        this.week_survey_date_avg$.next(resp);
      }
    );
    this.httpClient.get(environment.baseURL + '/v2/api' + '/chart_date_avg/month?' + type + '=' + id).subscribe(
      (resp: ChartModel[]) => {
        if (resp) {
          resp.forEach(x => {
            x.arg = new Date(x.arg);
          });
        }
        this.month_survey_date_avg$.next(resp);
      }
    );
  }

  getSurveyResult(type, itemId) {
    this.httpClient.get(environment.baseURL + '/v2/api' + '/survey_result_point?' + type + '=' + itemId);
  }


  postSurveyHeader(surveyHeader: SurveyResearchHeaderModel) {
    this.httpClient.post(environment.baseURL + '/v2/api' + '/survey_header', surveyHeader).subscribe(
      (resp) => {
        console.log(resp);
      }, (err) => {
        console.log(err);
      }, () => {
        this.getSurveyHeader(+JSON.parse(localStorage.getItem('token_form')).app_hotel_id);
      }
    );
  }

  getSurveyResearchByID(profile_id: number) {
    this.httpClient.get(environment.baseURL + '/v2/api' + '/survey_research/' + profile_id).subscribe(
      (survey: SurveyResearchModel[]) => {
        this.survey_result_change$.next(survey);
      }
    );
  }

  deleteResult(type, ID: number) {
    this.httpClient.delete(environment.baseURL + '/v2/api' + '/reset_survey/' + ID).subscribe(
      (resp) => {
        console.log(resp);
        this.GETChartResult(type, ID);
        this.getSurveyResult(type, ID);
      }, (err) => {
        console.log(err);
      }
    );
  }

  getNotificationResult(id) {
    this.httpClient.get<SurveyResearchHeaderModel>(environment.baseURL + '/v2/api' + '/survey_header/' + id).subscribe((data) => {
      this.notificationResultData_change$.next(data);
    });
  }
}
